import { __assign } from "tslib";
import { ApiTypes, } from '../sdk.types';
var DocumentParser = /** @class */ (function () {
    function DocumentParser(siteBaseUrl) {
        this.siteBaseUrl = siteBaseUrl;
    }
    DocumentParser.prototype.parseDefaultDocument = function (rawDocument) {
        return {
            title: rawDocument.title,
            image: rawDocument.documentImage,
            description: rawDocument.description,
            relativeUrl: rawDocument.url,
            url: "" + this.siteBaseUrl + rawDocument.url,
        };
    };
    DocumentParser.prototype.parse = function (rawDocument) {
        var documentType = rawDocument.documentType;
        switch (documentType) {
            case ApiTypes.SearchDocumentType.Products:
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { documentType: documentType, price: rawDocument.discountedPrice });
            case ApiTypes.SearchDocumentType.Pages:
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { documentType: documentType });
            case ApiTypes.SearchDocumentType.Blogs:
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { documentType: documentType });
            case ApiTypes.SearchDocumentType.Forums:
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { documentType: documentType });
            case ApiTypes.SearchDocumentType.Bookings:
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { documentType: documentType });
            case ApiTypes.SearchDocumentType.Events:
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { documentType: documentType });
            default:
                // typechecking if we forgot any SearchDocumentType.
                // in runtime, function will still work if we got an unknown document type from the backend
                var unknownDocumentType = documentType;
                console.warn("You're trying to parse unknown document type - " + rawDocument.documentType);
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { documentType: unknownDocumentType });
        }
    };
    return DocumentParser;
}());
export { DocumentParser };
//# sourceMappingURL=DocumentParser.js.map